import React from 'react'

const SDKIcon = () => {
  return (
    <svg
      width="60"
      height="52"
      viewBox="0 0 60 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="20" width="19" height="4" rx="2" fill="#09AA89" />
      <rect x="20" width="3" height="10" rx="1.5" fill="#09AA89" />
      <rect x="36" width="3" height="10" rx="1.5" fill="#09AA89" />
      <rect y="8" width="60" height="44" rx="5" fill="#09AA89" />
      <path
        d="M7.79492 37.1621C9.23438 37.8711 11.1035 38.2363 12.9727 38.2363C16.6465 38.2363 19.5254 36.3457 19.5254 33.3164C19.5254 28.5254 12.2422 29.2773 12.2422 27.3867C12.2422 26.6992 12.9941 26.1191 14.4551 26.1191C15.7656 26.1191 17.3125 26.5273 18.6875 27.3867V23.7988C17.2051 23.0469 15.8301 22.7246 14.1973 22.7246C10.5449 22.7246 8.20312 24.9805 8.20312 27.6016C8.20312 32.457 15.4004 31.6406 15.4004 33.5312C15.4004 34.5625 14.3047 34.8203 12.9727 34.8203C11.4688 34.8203 9.4707 34.3906 7.79492 33.4453V37.1621ZM21.9316 38H28.377C32.7812 38 36.3906 35.1426 36.3906 30.4805C36.3906 25.8184 32.7812 22.9609 28.377 22.9609H21.9316V38ZM25.9707 34.7129V26.248H28.334C30.7617 26.248 32.2871 27.9883 32.2871 30.4805C32.2871 32.9727 30.7617 34.7129 28.334 34.7129H25.9707ZM48.6367 38H53.5352L46.832 29.9434L52.9121 22.9609H48.1426L42.4922 29.7285V22.9609H38.4531V38H42.4922V30.5879L48.6367 38Z"
        fill="white"
      />
    </svg>
  )
}

export default SDKIcon
